import { useLocation, useNavigate } from 'react-router'

const usePreviousPath = () => {
  const location = useLocation()
  const navigate = useNavigate()
  return {
    generatePreviousPath: (fallbackPath: string) =>
      location.key === 'default' ? fallbackPath : -1,
    navigateToPrevious: (fallbackPath: string) => {
      location.key === 'default' ? navigate(fallbackPath) : navigate(-1)
    },
  }
}
export default usePreviousPath
